import styled from 'styled-components';
import {
  DialogBody,
  Flex,
  Grid,
  Image,
  LoadingMask,
  mediaBreakpointMixin,
  ModalDialog,
  PropertyCard,
  spaceMixin,
  StyledDialog,
} from '@zillow/constellation';

export const BlockLoadingMask = styled(LoadingMask)`
  display: block;
`;

export const MinHeightLoadingMask = styled(BlockLoadingMask)`
  min-height: 30vh;
`;

export const TallHeightLoadingMask = styled(BlockLoadingMask)`
  min-height: 70vh;
`;

export const FullHeightLoadingMask = styled(BlockLoadingMask)`
  height: 100%;
`;

export const HiddenLGAndAbove = styled.span`
  @media ${mediaBreakpointMixin('lg')} {
    display: none;
  }
`;

export const HiddenMDAndBelow = styled.span`
  @media ${mediaBreakpointMixin('md_lte')} {
    display: none;
  }
`;

// Override constellation padding and height adjustments to prevent double scrolling bars.
export const ModalWithFullHeightBody = styled(ModalDialog)`
  > ${StyledDialog} {
    height: 100%;
  }
  ${DialogBody} {
    :after {
      height: 0 !important;
    }
    height: 100%;
    padding: 0 !important;
  }
`;

export const FullWidthPropertyCard = styled(PropertyCard)`
  max-width: 100% !important;
`;

export const GridDesktopOnly = styled(Grid)`
  @media ${mediaBreakpointMixin('lg_lte')} {
    display: none;
  }
`;

export const IncomeDocPreviewImage = styled(Image)`
  height: ${spaceMixin(24)};
  object-fit: contain;
`;

export const IncomeDocSpinnerSpacer = styled(Flex)`
  height: ${spaceMixin(24)};
  object-fit: contain;
`;

export const InlineDt = styled.dt`
  display: inline;
`;

export const InlineDd = styled.dd`
  display: inline;
`;

export const PrintHidden = styled.div`
  @media print {
    display: none;
  }
`;

export const PrintOnly = styled.div`
  display: none;
  @media print {
    display: block;
  }
`;
